var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafeAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#022449",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 40.645 40.645",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.396,16.118c0.004-0.089,0.006-0.178,0.006-0.268c0-6.831-5.558-12.389-12.39-12.389c-4,0-7.675,1.892-10.006,5.104 c-0.802-0.361-1.672-0.549-2.561-0.549c-3.453,0-6.262,2.81-6.262,6.263c0,0.407,0.041,0.813,0.121,1.214 C2.055,17.121,0,20.409,0,24.097c0,5.313,4.324,9.64,9.64,9.64H10c1.583,2.09,4.083,3.446,6.906,3.446 c2.04,0,3.912-0.711,5.393-1.889c1.021,0.563,2.197,0.887,3.449,0.887c2.15,0,4.072-0.95,5.385-2.45 c5.256-0.07,9.512-4.361,9.512-9.634C40.644,20.907,39.031,17.903,36.396,16.118z M31.646,18.841l-8.322,8.323 c-0.392,0.393-0.902,0.587-1.415,0.587c-0.511,0-1.021-0.194-1.413-0.585l-5.153-5.143c-0.782-0.781-0.783-2.048-0.002-2.83 c0.781-0.781,2.047-0.782,2.829-0.002l3.738,3.731l6.908-6.912c0.78-0.78,2.047-0.781,2.83,0 C32.426,16.793,32.426,18.059,31.646,18.841z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeAlarm);
export default __webpack_public_path__ + "static/media/safe_alarm.793d86322e33e017bd374eec9a4b4d3f.svg";
export { ForwardRef as ReactComponent };